'use client';

import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["theme"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as React from 'react';
import ThemeProviderNoVars from "./ThemeProviderNoVars.js";
import { CssVarsProvider } from "./ThemeProviderWithVars.js";
import THEME_ID from "./identifier.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default function ThemeProvider(_ref) {
  var theme = _ref.theme,
      props = _objectWithoutProperties(_ref, _excluded);

  if (typeof theme === 'function') {
    return /*#__PURE__*/_jsx(ThemeProviderNoVars, _objectSpread({
      theme: theme
    }, props));
  }

  var muiTheme = THEME_ID in theme ? theme[THEME_ID] : theme;

  if (!('colorSchemes' in muiTheme)) {
    return /*#__PURE__*/_jsx(ThemeProviderNoVars, _objectSpread({
      theme: theme
    }, props));
  }

  return /*#__PURE__*/_jsx(CssVarsProvider, _objectSpread({
    theme: theme
  }, props));
}